import Box, { BoxProps } from '@mui/material/Box';
import animationData from 'assets/lotties/sadRobot.json';
import LottiePlayer from 'components/LottiePlayer';

import React from 'react';

const RobotError: React.FC<BoxProps> = React.memo((props) => {
    return (
        <Box {...props} style={{ height: '100%', width: '30%' }}>
            <LottiePlayer loop={true} animationData={animationData} />
        </Box>
    );
});

export default React.memo(RobotError);
